import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { findFlagUrlByNationality } from 'country-flags-svg';

import { listStringToObject } from '../../../../utils/utils';
import { useToggle } from '../../../../hooks/useToggle';
import ToggleButton from '../../../ToggleButton';
import ProfessionnalEducation from './ProfessionnalEducation';

const useStyles = createUseStyles((theme) => ({
  professionnal: {},
  items: {
    padding: 0,
    margin: 0,
    '& > li': {
      listStyle: 'none',
      marginBottom: theme.spacing(1),
    },
  },
  langItems: {
    composes: 'flexRow',
    margin: -theme.spacing(0.5),
    '& > li': {
      margin: theme.spacing(0.5),
    },
  },
  item: {
    listStyle: 'none',
  },
  lang: {
    marginBottom: theme.spacing(1),
  },
  education: {},
  flagImage: {
      width: 24,
      border: '0.5px solid grey',
  }
}));

const Professionnal = ({ result }) => {
  const classes = useStyles();

  const { open, toggle } = useToggle();

  const educations = listStringToObject(result?.us_educ_list);

  return (
    <div className={classes.professionnal}>
      <div className={classes.lang}>
        <ul className={clsx(classes.langItems, classes.items)}>
          {result?.lang_from_first?.raw && result?.lang_from_first?.raw.split(',').find(lang => findFlagUrlByNationality(lang.trim())) && (
            <li className={classes.item}>
              Lang:
            </li>
          )}
          {result?.lang_from_first?.raw.split(',').map((lang, index) => (
              findFlagUrlByNationality(lang.trim())
              ? (
                <li className={classes.item} key={index}>
                  <img alt="" src={findFlagUrlByNationality(lang.trim())} className={classes.flagImage} />
                </li>
              )
              : <div key={index} />
          ))}
        </ul>
      </div>
      <ul className={classes.items}>
        {educations[0] && (
          <ProfessionnalEducation
            result={result}
            data={educations[0]}
            label="Education 1 :"
          />
        )}
        {open && educations.length > 1 && (
          <li>
            <ul className={classes.items}>
              {educations.filter((_, i) => i !== 0).map((education, index) => (
                <ProfessionnalEducation
                  result={result}
                  data={education}
                  label={"Education "+ (index + 2) + ' : '}
                  key={index}
                />
              ))}
            </ul>
        </li>
        )}
        {educations.length > 1 && (
          <li>
            <ToggleButton onClick={toggle} open={open} />
          </li>
        )}
      </ul>
    </div>
  );
}

export default Professionnal;